import React, { useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import "./style.css";
import { Button, Form, FormInstance } from "antd";
import { shelterSettingSponsorShipDelete, shelterSettingSponsorShipList, shelterSettingSponsorShipSave, shelterSettingSponsorShipUpdate } from "services/api";
import { BaseContextProvider } from "context/BaseContext";
import { DonationSponsorEditTable } from "./DonationSponsorEdit";

interface IDonationSponsorItemTable {
  donation_list: {
    description: string;
    amount: string;
    uuid?: string;
  }[]
}

export interface IDonationSponsorProps {
  uuid: string;
}

const DonationSponsor = React.forwardRef<{ handleSave: () => Promise<void> }, IDonationSponsorProps>((props, ref) => {
  const formRef = useRef<FormInstance<any>>(null)
  const tableRef = useRef<{ reset: () => void, add: () => void }>(null)
  const [form] = Form.useForm()
  const [update, setUpdate] = useState(false)
  const [initialValues, setInitialValues] = useState<{} | null>(null)
  const [hasDefault, setHasDefault] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isEditing, setIsEditing] = useState(false)

  useImperativeHandle(
    ref,
    () => ({
      handleSave: async () => {
        return await new Promise<void>((resolve) => {
          tableRef.current?.reset()
          formRef.current?.submit()
          resolve()
        })
      }
    }),
    [],
  )

  useEffect(() => {
    donationSponsorList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const donationSponsorList = async () => {
    const donationValues = await shelterSettingSponsorShipList({
      "search": {
        "deleted": false,
        "shelter": {
          "has": {
            "uuid": props.uuid,
            "_exists": true
          }
        }
      },
      "options": {
        "limit": 10,
      }
    })
    // const donationValues = {data: { data: {result: []}}} as any
    if (!donationValues.data.data?.result.length) {
      setHasDefault(true)
      setUpdate(false)
      const donationDefaultValues = await shelterSettingSponsorShipList({
        "search": {
          "deleted": false,
          "shelter_id": { "isNull": true },
        },
        "options": {
          "limit": 10,
          "sort": [
            "created_date"
          ]
        }
      })

      const arr: any = {}
      if (!!donationDefaultValues.data.data?.result.length) {
        const fromData = donationDefaultValues.data.data?.result.reduce((prv, cc, i) => {
          if (Object.keys(cc).includes("amount")) {
            arr[`amount-${i}`] = cc.amount;

          }
          if (Object.keys(cc).includes("description")) {
            arr[`description-${i}`] = cc.description;
          }
          return arr
        }, {} as any)

        setInitialValues(fromData)
        setIsLoading(false)

        // form.setFieldsValue(fromData)
      }

      return
    }

    const arr: any = {}
    if (!!donationValues.data.data?.result.length) {
      setUpdate(true)
      setHasDefault(false)
      const formData = donationValues.data.data?.result.reduce((prv, cc, i) => {
        if (Object.keys(cc).includes("uuid")) {
          arr[`uuid-${i}`] = cc.uuid;
        }
        if (Object.keys(cc).includes("amount")) {
          arr[`amount-${i}`] = cc.amount;

        }
        if (Object.keys(cc).includes("description")) {
          arr[`description-${i}`] = cc.description;
        }

        return arr
      }, {} as any)

      setInitialValues(formData)
      setIsLoading(false)

      // form.setFieldsValue(formData)
    }

  }

  const processResponse = (response) => {
    const baseContext = new BaseContextProvider({});
    return baseContext.processResponse(response);
  };

  const saveDonationSponsor = async ({ donation_list }: IDonationSponsorItemTable) => {
    if (!!donation_list?.length) {
      const resArr = new Promise((resolve) => donation_list.map(async (value, i) => {

        try {
          const item = {
            description: value.description,
            amount: value.amount,
            uuid: value.uuid
          }

          const res = update && item.uuid
            ? await shelterSettingSponsorShipUpdate({ shelter_uuid: props.uuid, ...item })
            : await shelterSettingSponsorShipSave({ shelter_uuid: props.uuid, ...item })


          resolve(res)

        } catch (error) {
          console.log(error)
        }
      }))

      const result = await resArr
      await donationSponsorList()
      processResponse(result)
    }

  }



  const data = initialValues && Object.keys(initialValues).reduce((acc: any[], key) => {
    const [prop, index] = key.split("-");
    const currentIndex = parseInt(index);

    if (!acc[currentIndex]) {
      acc[currentIndex] = { currentIndex };
    }

    if (prop === "amount") {
      acc[currentIndex].amount = initialValues[key];
    } else if (prop === "description") {
      acc[currentIndex].description = initialValues[key];
    }
    else if (prop === "uuid") {
      acc[currentIndex].uuid = initialValues[key];
    }

    return acc;
  }, []);


  const handleDelete = async (uuid: string) => {
    setIsLoading(true)
    const res = await shelterSettingSponsorShipDelete({ uuid })
    await donationSponsorList()
    await processResponse(res)
  }


  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dataSource = useMemo(() => data || [], [initialValues, hasDefault, update])
  return (
    <div className="donation-sponsor-row">
      <Form
        form={form}
        // onFieldsChange={(v) => {
        //   v.forEach(((f, v) => {
        //     formRef.current?.setFields([{ name: f.name, errors: [], value: f.value }])
        //   }))
        // }}
        ref={formRef}
        layout="vertical"
        onFinish={saveDonationSponsor}>

        <div className="donation-sponsor-header" >
          <div>
            <h1>Sponsor Me donation options</h1>
            <p>Customize the Sponsor Me title and descriptions for this shelter</p>
          </div>
          <Button shape="round" type="primary" disabled={isEditing} onClick={() => {
            if (tableRef.current) {
              tableRef.current?.add()
            }
          }} >New</Button>
        </div>
        <Form.Item name="donation_list">

          <DonationSponsorEditTable
            hasDefault={hasDefault}
            ref={tableRef}
            data={dataSource}
            onDelete={handleDelete}
            loading={isLoading}
            onEditing={setIsEditing}
          />
        </Form.Item>

      </Form>


    </div >

  );
})

export { DonationSponsor };